<template>
	<v-card class="mx-auto" v-if="location">
		<v-card-title>{{ location.name }}</v-card-title>
		<v-img
			v-if="location.image"
			class="white--text align-end"
			max-height="100%"
			:src="
				`https://${keyword}.libnet.info/images/locations/${keyword}/${location.image}`
			"
		>
		</v-img>
		<v-list dense>
			<v-list-item v-if="location.manager">
				<v-list-item-avatar color="grey" v-if="location.manager_image">
					<v-img
						:src="
							`https://${keyword}.libnet.info/images/managers/${keyword}/${location.manager_image}`
						"
					></v-img>
				</v-list-item-avatar>
				<v-list-item-icon v-else>
					<v-icon>perm_identity</v-icon>
				</v-list-item-icon>

				<v-list-item-content>
					<v-list-item-subtitle>Branch manager</v-list-item-subtitle>
					<v-list-item-title
						v-text="location.manager"
					></v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item v-if="location.tel">
				<v-list-item-icon color="grey">
					<v-icon>local_phone</v-icon>
				</v-list-item-icon>

				<v-list-item-content>
					<v-list-item-title
						v-text="location.tel"
					></v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-list-item v-if="location.email">
				<v-list-item-icon color="grey">
					<v-icon>email</v-icon>
				</v-list-item-icon>

				<v-list-item-content>
					<v-list-item-title
						v-text="location.email"
					></v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-list-item>
				<v-list-item-icon color="grey">
					<v-icon>location_on</v-icon>
				</v-list-item-icon>

				<v-list-item-content>
					<v-list-item-title
						v-if="location.line1"
						v-text="location.line1"
					></v-list-item-title>
					<v-list-item-title
						v-if="location.line2"
						v-text="location.line2"
					></v-list-item-title>
					<v-list-item-title
						v-if="location.line3"
						v-text="location.line3"
					></v-list-item-title>
					<v-list-item-title
						v-if="location.locality"
						v-text="
							!location.stateprovincecounty
								? `${location.locality} ${location.ziporpostcode}`
								: `${location.locality}, ${location.stateprovincecounty} ${location.ziporpostcode}`
						"
					></v-list-item-title>
					<v-list-item-title class="py-3">
						<span
							@click="toggleMap"
							class="maplink text-decoration-underline blue--text"
						>
							<p v-if="!this.$store.state.showMap">
								{{ $t('global.show') }}
								{{ $t('global.map').toLowerCase() }}
							</p>
							<p v-if="this.$store.state.showMap">
								{{ $t('global.hide') }}
								{{ $t('global.map').toLowerCase() }}
							</p>
						</span>
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list>
		<v-card-text>
			<div v-html="location.description"></div>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	props: {
		id: { type: Number, required: true }
	},
	created() {
		this.keyword = window.config.keyword;
	},
	mounted() {
		this.$store.dispatch('fetchLocations');
	},
	computed: {
		location() {
			return this.$store.getters.getLocationForId(this.id);
		}
	},
	methods: {
		toggleMap() {
			this.$store.state.showMap = !this.$store.state.showMap;
		}
	}
};
</script>

<style>
.maplink {
	text-decoration: underline;
	cursor: pointer;
}
</style>
